import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { colors, spacing, subtitle2 } from 'ui/theme';
import { Close16 } from 'ui/icons';

const ItemWrapper = styled.div`
  ${subtitle2}
  display: flex;
  padding: ${spacing.base};
  margin-bottom: ${spacing.base};

  align-items: center;
  gap: ${spacing.half};
  align-self: stretch;

  border-radius: ${spacing.half};
  background-color: ${colors.backgroundSecondary};
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  flex: 1 1 auto;
`;

const CloseButton = styled(IconButton)`
  padding: ${spacing.half};
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
  flex: 0 0 auto;
`;

interface DisplayUntilItemProps {
  onClose?: () => void;
}

export const CLOSE_DISPLAY_UNTIL_ITEM_TEST_ID = 'close-display-until-item';

const DisplayUntilItem = ({
  children,
  onClose,
  ...props
}: PropsWithChildren<DisplayUntilItemProps>) => {
  const hasCloseButton = typeof onClose === 'function';

  return (
    <ItemWrapper {...props}>
      <ContentWrapper>{children}</ContentWrapper>
      {hasCloseButton && (
        <CloseButton
          data-test={CLOSE_DISPLAY_UNTIL_ITEM_TEST_ID}
          variant={BUTTON_VARIANTS.GHOST}
          onClick={onClose}
        >
          <Close16 />
        </CloseButton>
      )}
    </ItemWrapper>
  );
};

export default DisplayUntilItem;
